export default "__VITE_ASSET__D6qF1TdX__"